module.exports = __webpack_public_path__ + "img/chara_line_1.76564cda.png";